<template>
  <aside class="menu">
    <div class="menu__image__wrapper">
      <router-link to="/" class="menu__image">
        <img src="/img/top_logo.png" alt="Logo image" class="menu__image" />
      </router-link>
    </div>
    <ul class="menu-list">
      <li>
        <router-link to="/">{{ $t('menu.home') }}</router-link>
      </li>
      <li>
        <router-link to="/servers">{{ $t('menu.servers') }}</router-link>
      </li>
      <li>
        <router-link to="/lists">{{ $t('menu.lists') }}</router-link>
      </li>
      <li>
        <router-link to="/user_settings">{{ $t('menu.user_settings') }}</router-link>
      </li>

      <li v-if="isAdmin">
        <router-link to="/system_settings">{{ $t('menu.system_settings') }}</router-link>
      </li>
      <li v-if="isAdmin">
        <router-link to="/ui_settings">{{ $t('menu.ui_settings') }}</router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex'
const { mapState: mapUserState } = createNamespacedHelpers('general')
export default {
  name: 'AsideMenu',
  data() {
    return {
      currentUser: {}
    }
  },
  created() {
    this.fetchCurrentUser()
  },
  computed: {
    ...mapUserState({
      stateUser: state => {
        return state.user
      }
    }),
    isAdmin() {
      if (this.currentUser) {
        return this.currentUser.role === 'ADMIN'
      }
      return false
    }
  },
  methods: {
    ...mapActions('general', ['setUser', 'setUserAlarms']),
    fetchCurrentUser() {
      if (!this.loadingCurrentUser) {
        const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/settings/user`
        this.loadingCurrentUser = true
        return fetch(url, {
          method: 'GET',
          credentials: 'include'
        })
          .then(res => {
            if (!res.ok) {
              throw res.json()
            }
            return res.json()
          })
          .then(data => {
            this.currentUser = data
          })
          .catch(error => {
            error.then(data => {
              this.$notify({
                message: JSON.parse(data.message).message,
                type: 'danger'
              })
            })
          })
          .finally(() => {
            this.loadingCurrentUser = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
  &__image {
    height: 52px;
    max-width: 215px;

    &__wrapper {
      height: calc(52px + 0.6rem);
      padding: 0.3rem;
      width: 100%;
      background: #1c2b36;

      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }

  li {
    a {
      color: #fff !important;
      padding-left: 20px;
      padding-top: 0.75rem;
      padding-bottom: 0.75rem;
    }
    a:hover {
      background-color: unset;
      color: #209e91 !important;
      border-right: #209e91 5px solid;
    }
    a.is-active {
      border-radius: 0;
      background-color: #505050;
    }
  }
}
</style>
